import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {Response, Headers, RequestOptions, Http} from '@angular/http';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {IncidentReportsService} from '../../../services/incident-reports.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, IncidentReport} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {environment} from '../../../../environments/environment';
import { AuthTokenService } from '../../../services/auth-token.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'incident-reports-modal',
    templateUrl: './incident-reports-modal.component.html',
    styleUrls: ['./incident-reports-modal.component.scss']
})
export class IncidentReportsModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    incidentTypes: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: IncidentReport = new IncidentReport();
    disabledSubmit = false;
    date: string = (new Date).toISOString();
    time = IncidentReportsModalComponent.parseTime((new Date()).toISOString());
    buildingSelectIsDisabled = false;
    isEditModeNoSpinner = false;
    maxDate = new Date();
    attachments = [];
    disabledFileInput = false;
    showSpinner = false;

    static parseTime(dateString: string): string {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    constructor(
        public api: ApiClientService,
        public incidentReportsService: IncidentReportsService,
        public authService: AuthenticationService,
        public urlService: UrlService,
        private http: Http,
        private authTokenService: AuthTokenService
    ) {}

    ngOnInit() {
        this.initData();
        this.initTimePicker();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initTimePicker() {
        $('#timepicker1').timepicker().on('changeTime.timepicker', e => this.time = e.time.value);
    }

    openTimepicker(): void {
        $('#timepicker1').timepicker('showWidget');
    }

    initData() {
        this.getIncidentTypes();
        this.isEditModeNoSpinner = false;
        if (this.incidentReportsService.incidentReportInIncidentReportsModal) {
            this.data = this.incidentReportsService.incidentReportInIncidentReportsModal;
            this.date = this.data.createdAt;
            this.time = IncidentReportsModalComponent.parseTime(this.data.createdAt);
            this.isEditModeNoSpinner = true;
            if (this.data.suiteId)
                this.suites = [{id: this.data.suiteId, name: this.data.suiteNumber}];
            else
                this.suites = [{id: 0, name: 'Other'}];
            if (this.data.residentId)
                this.residents = [new ResidentForSelect(this.data.residentId, this.data.residentFullName)];
            else
                this.residents = [new ResidentForSelect(0, 'Other')];
            if(!this.data.incidentReportType) {
                this.data.incidentReportType = {};
                this.data.incidentReportType.id = '0';
            }

            this.getSuites(this.data.buildingId, this.data.suiteId);
        } else {
            const b = this.urlService.queryParams['building'];
            if (b) {
                this.data.buildingId = b;
                this.getSuites(this.data.buildingId);
            }

            if (this.incidentReportsService.buildings.length === 1) {
                this.data.buildingId = this.incidentReportsService.buildings[0].id;
                this.getSuites(this.data.buildingId);
            }
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.incidentReportsService.isIncidentReportModalShow = false;
                    this.incidentReportsService.incidentReportInIncidentReportsModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.incidentReportsService.isIncidentReportModalShow = false;
            this.incidentReportsService.incidentReportInIncidentReportsModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.buildingId) toastr.warning('Building should not be blank.');
            if ((!form.value.suiteId && this.form.value.suiteId !== 0) ||
                (this.form.value.suiteId === 0 && !form.value.otherSuite))
                toastr.warning('Unit should not be blank.');
            if ((!form.value.residentId && this.form.value.suiteId !== 0) ||
                (this.form.value.residentId === 0 && !form.value.otherResident))
                toastr.warning('Resident should not be blank.');
            if (!form.value.date)       toastr.warning('Date should not be blank and must consist of valid day, month and year.');
            if (!form.value.time)       toastr.warning('Time should not be blank.');
            if (!form.value.reportedBy) toastr.warning('Reported By should not be blank.');
            if (form.value.incidentReportType === undefined)
                toastr.warning('Type field should not be blank');
            if (form.value.incidentReportType === 0 && !form.value.incidentReportTypeOther)
                toastr.warning('Other Type field should not be blank');
            return;
        }
        const building = this.incidentReportsService.buildings.find((item) => item.id == form.value.buildingId);
        const suite    = this.suites.find((item) => item.id == form.value.suiteId);
        const resident = this.residents.find((item) => item.id == form.value.residentId);

        const data: any = {
            building: {
                bdId: form.value.buildingId ? form.value.buildingId : 0,
                name: building ? building.name : null,
                address: building && building.address ? building.address : ''
            },
            suite: {
                bdId:        suite && suite.id ? form.value.suiteId : 0,
                suiteNumber: suite && suite.id ? suite.name         : form.value.otherSuite,
            },
            resident: {
                bdId:     resident && resident.id ? resident.id       : 0,
                fullName: resident && resident.id ? resident.fullName : form.value.otherResident,
            },
            incident:           form.value.incident,
            incidentAt:          this.getDateTimeFromForm(),
            createdBy:          {fullName: this.authService.user.fullName, email: this.authService.user.email},
            reportedBy:         form.value.reportedBy,
            reportedArea:       form.value.reportedArea,
            incidentReportType: form.value.incidentReportType == 0 ? null : form.value.incidentReportType,
            incidentReportTypeOther: form.value.incidentReportType == 0 ? form.value.incidentReportTypeOther :  '',
            attachments: this.attachments.length > 0 ? this.attachments : undefined
            // securityCompanyLogo: building.securityCompanyLogo

        };

        this.disabledSubmit = true;

        if (this.data.id) {
            this.api.patch('domainIncidentReports', `/v1/incident_report/${this.data.id}.json`, data).subscribe(
                () => this.updateView('Incident Report successfully updated'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Edit Incident Report failed');
                }
            );
        } else {
            this.api.post('domainIncidentReports', '/v1/incident_report.json', data).subscribe(
                () => this.updateView('Incident Report successfully created'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Create Incident Report failed');
                }
            );
        }
    }

    getDateTimeFromForm(): Date {
        const date = new Date(this.form.value.date);
        const time = this.form.value.time;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours   = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return moment(date).format('YYYY-MM-DD HH:mm');
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.incidentReportsService.getData();
        this.form.reset();
        this.hideModal();
    }

    typeSelect(arr: Array<any>) {
        return arr.map(incidentReportType => ({value: incidentReportType.id, optionText: incidentReportType.name}));
    }

    changeBuilding(buildingId: string) {
        this.isEditModeNoSpinner = false;
        this.form.controls['suiteId'].reset();
        this.form.controls['residentId'].reset();
        this.getSuites(+buildingId);
    }

    changeUnit(suiteId: string) {
        if (+suiteId != this.data.suiteId) {
            this.isEditModeNoSpinner = false;
            this.form.controls['residentId'].reset();
            this.getResidents(+suiteId);
            if (suiteId + '' === '0') {
                this.form.controls['residentId'].setValue(0);
                this.data.residentId = 0;
                this.data.suiteNumber = '';
                this.data.residentFullName = '';
                this.residents.push(new ResidentForSelect(0, 'Other'));
            }
        }
    }

    changeResident(residentId: string) {
        this.isEditModeNoSpinner = false;
        if (residentId === '0') this.data.residentFullName = '';
    }

    getIncidentTypes() {
        const url = `/v1/incident-reports-types.json?per-page=1000`;
        this.api.get('domainIncidentReports', url).subscribe(
            res => {
                this.incidentTypes = [];
                const types = JSON.parse(res._body).entities || [];
                this.incidentTypes = types.map(type => ({id: type.id, name: type.name}));
                this.incidentTypes.push({id: 0, name: 'Other'});
            },
            error => this.api.errorHandler(error, 'Failed get types')
        );
    }

    getSuites(buildingId: number, suiteId?: number): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.suites = [];
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId) this.getResidents(suiteId);
            },
            error => this.api.errorHandler(error, 'Failed get suites'),
                () => this.buildingSelectIsDisabled = false
        );
    }

    getResidents(suiteId: number): void {
        if (!suiteId) return;
        const url = `/v1/residents/select.json?per-page=1000&suite_id=${suiteId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.residents = [];
                if(this.form.value.suiteId !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    this.residents = residents.map(item =>
                        (new ResidentForSelect(item.id, item.fullName, [], item.email))
                    );
                }
                this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    addFile(e) {
        const file = e.target.files[0];
        const fd   = new FormData();
        e.target.value = null;
        
        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token   = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.showSpinner = true;
        this.disabledFileInput = true;
        this.disabledSubmit = true;
        this.http.post(`${environment.domainServiceRequest}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) { toastr.warning('Attachment path should not be blank.'); return; }
                const attachment = {name: file.name, fileSize: file.size, link: res.path};
                this.attachments.push(attachment);
                this.showSpinner = false;
                this.disabledFileInput = false;
                this.disabledSubmit = false;
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
                this.showSpinner = false;
                this.disabledFileInput = false;
                this.disabledSubmit = false;
            }
        );
    }

    removeFile(i: number) {
        swal(
            ConstantsService.getSwalConfig('Delete Attachment'),
            () => this.attachments.splice(i, 1)
        );
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-reports-modal/incident-reports-modal.component.ts